import { createSlice } from '@reduxjs/toolkit'

const sessionDetailSlice = createSlice({
  name: 'sessionDetail',
  initialState: {},
  reducers: {
    updateSessionDetail: (state, action) => {
      const { conversationID, object } = action.payload
      return {
        ...state,
        [conversationID]: { ...state[conversationID], ...object },
      }
    },
    removeSessionDetail: (state, action) => {
      const { conversationID } = action.payload
      if (conversationID) {
        delete state[conversationID]
      } else {
        return {}
      }
    },
    removeForm: (state, action) => {
      const { conversationID, formName } = action.payload
      if (state[conversationID]) {
        delete state[conversationID][formName]
      }
    },
  },
})

export const { updateSessionDetail, removeSessionDetail, removeForm } =
  sessionDetailSlice.actions
export default sessionDetailSlice.reducer
